import React from "react";
import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { Particles } from "@/components/Particles";
import { Footer } from "@/components/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen relative">
      <Particles />
      <Navigation />
      <main className="relative z-10">
        <HeroSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;